import { useEffect, useState } from "react";

const useMediaQuery = (query) => {
    const getMatches = (query) => {
        if (typeof window !== "undefined") {
            return window.matchMedia(query).matches;
        }
        return false;
    }

    const [matches, setMatches] = useState(getMatches(query));

    useEffect(() => {
        const mediaQueryList = window.matchMedia(query);
        const listener = (event) => setMatches(event.matches);

        mediaQueryList.addEventListener("change", listener);
        setMatches(mediaQueryList.matches); // In case query changes

        return () => {
            mediaQueryList.removeEventListener("change", listener);
        };
    }, [query]);

    return matches;
}

export default useMediaQuery;
